import { render } from "./NoProvider.vue?vue&type=template&id=3408b640&scoped=true"
import script from "./NoProvider.vue?vue&type=script&lang=js"
export * from "./NoProvider.vue?vue&type=script&lang=js"

import "./NoProvider.vue?vue&type=style&index=0&id=3408b640&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3408b640"]])

export default __exports__